module.exports = __webpack_public_path__ + "static/media/IMG_0870-min.f809249b.jpg";